const searchAdvancedSection = document.querySelector('.search-advanced');

if (searchAdvancedSection) {

    const searchAdvancedItems = searchAdvancedSection.querySelectorAll('.search-advanced__item');
    const searchAdvancedButton = searchAdvancedSection.querySelector('.search-advanced__button');

    searchAdvancedItems.forEach(item => {
        item.addEventListener('click', () => {
            searchAdvancedItems.forEach(itemBis => {
                itemBis.removeAttribute('selected');
            })
            item.setAttribute('selected', '');
            searchAdvancedButton.href = item.dataset.url;
        })

    })
}